export default "__VITE_ASSET__sFX1QBem__"